<template>
  <div>
    <a-modal
      width="1000px"
      v-model="isShow"
      centered
      :mask-closable="false"
      title="预制订单详情"
    >
      <template slot="footer">
        <a-button class="ant-btn-primary" @click="closeModal">
          关闭
        </a-button>
      </template>
      <a-row>
        <a-col :span="colSpan">
          <a-descriptions
            title="基本信息"
            :column="1"
            class="simiot-descriptions"
          >
            <a-descriptions-item label="客户名称">
              {{ data.agent_name }}
            </a-descriptions-item>

            <a-descriptions-item label="订单编号">
              {{ data.order_no }}
            </a-descriptions-item>

            <a-descriptions-item label="订单类型">
              {{ data.order_type }}
            </a-descriptions-item>

            <a-descriptions-item label="项目数量">
              {{ data.items_count }}
            </a-descriptions-item>

            <a-descriptions-item label="订单状态">
              {{ data.status }}
            </a-descriptions-item>

            <a-descriptions-item label="创建时间">
              {{ data.created_at }}
            </a-descriptions-item>

            <a-descriptions-item label="订单备注">
              {{ data.remark }}
            </a-descriptions-item>
          </a-descriptions>
        </a-col>
        <a-col :span="colSpan">
          <a-descriptions
            title="订单金额"
            :column="1"
            class="simiot-descriptions simiot-descriptions-max-6"
          >
            <a-descriptions-item label="总数量">
              {{ data.card_count }}
            </a-descriptions-item>

            <a-descriptions-item label="订单金额(元)">
              {{ data.order_fee | formatFloat }}
            </a-descriptions-item>
          </a-descriptions>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { findAgentPreOrder } from '@/api/agent_pre_order'
export default {
  name: 'ShowAgentPreOrder',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {},
      agreement: {},
      colSpan: 12,
      isSelfTake: false,
      isPost: false,
      isShowDeliveryInfo: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    // 获取采购订单信息
    fetchData() {
      findAgentPreOrder(this.id).then((res) => {
        this.data = res.data
        this.agreement = res.data.agreement
        this.agreement.name = `《${this.agreement.name}》`
        this.isPost = this.data.pickup_way_slug === 'post'
        this.isSelfTake = this.data.pickup_way_slug === 'self_take'
        if (['delivered', 'finished'].includes(this.data.status_slug)) {
          this.isShowDeliveryInfo = true
          this.colSpan = 6
        }
      })
    },

    closeModal() {
      this.isShow = false
    }
  }
}
</script>
